"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.callAnyPromiseWithTimeout = exports.sleep = exports.chunk = void 0;
/**
 * Split an array into chunks
 *
 * @param arr array
 * @param size chunk size
 */
const chunk = (arr, size) => {
    return [...Array(Math.ceil(arr.length / size))].map((_, i) => arr.slice(size * i, size + size * i));
};
exports.chunk = chunk;
/**
 * Sleep
 *
 * @param ms duration to sleep
 */
const sleep = (ms) => {
    return new Promise(resolve => setTimeout(resolve, ms));
};
exports.sleep = sleep;
/**
 * This takes a promise and limits it to a certain time.
 * If the promise does not resolve within the time, it will reject with a timeout error.
 *
 * @param promise to call
 * @param timeout in milliseconds
 * @param error to reject with if timeout is reached
 * @param log logger
 */
const callAnyPromiseWithTimeout = (promise, timeout, error, log) => {
    let timeoutId;
    const timeoutPromise = new Promise((_, reject) => {
        timeoutId = setTimeout(() => {
            reject(error);
        }, timeout);
    });
    return Promise.race([promise, timeoutPromise])
        .then(value => {
        clearTimeout(timeoutId); // Clear the timeout upon resolution
        log.info("Promise resolved within timeout.");
        return value;
    })
        .catch(reason => {
        if (reason === error) {
            log.error("Promise rejected due to timeout.");
        }
        else {
            // Not the timeout error
            clearTimeout(timeoutId);
            log.error("Promise rejected within timeout.");
        }
        throw reason;
    });
};
exports.callAnyPromiseWithTimeout = callAnyPromiseWithTimeout;
//# sourceMappingURL=commonUtils.js.map